import { AxiosInstance } from 'axios';
import axiosRetry, { IAxiosRetryConfig } from 'axios-retry';

const withRetries =
  (config: IAxiosRetryConfig = {}) =>
  (axios: AxiosInstance): AxiosInstance => {
    axiosRetry(axios as any, config);
    return axios;
  };

export default withRetries;
